// extracted by mini-css-extract-plugin
export default {"wrapper":"TopBar_wrapper__QICmI","background":"TopBar_background__rTDDj","content":"TopBar_content__2um7B","logo":"TopBar_logo__iw5bo","center":"TopBar_center__2kfUP"};